<template>
<div class="chapter">
<div class="inner_page">
<p class="para"><br class="calibre2"/></p>
<p class="para"><br class="calibre2"/></p>
<p class="para"><br class="calibre2"/></p>
<p class="para" id="para1">J. Hillis Miller is Distinguished Research Professor of Comparative Literature and English at the University of California, Irvine. He is the author of many books and articles on literature and literary theory, most recently of <em class="italic">For Derrida</em>.</p>
<p class="para"><br class="calibre2"/></p>
<p class="para" id="para2">The University of Chicago Press, Chicago 60637<br class="calibre2"/>
  The University of Chicago Press, Ltd., London<br class="calibre2"/>
  © 2011 by The University of Chicago<br class="calibre2"/>
  All rights reserved. Published 2011.<br class="calibre2"/>
  Printed in the United States of America</p>
<p class="para"><br class="calibre2"/></p>
<p class="para" id="para3">20 19 18 17 16 15 14 13 12 11            1 2 3 4 5</p>
<p class="para"><br class="calibre2"/></p>
<p class="para" id="para4">ISBN-13: 978-0-226-52721-5 (cloth)<br class="calibre2"/>
  ISBN-13: 978-0-226-52722-2 (paper)<br class="calibre2"/>
  ISBN-10: 0-226-52721-2 (cloth)<br class="calibre2"/>
  ISBN-10: 0-226-52722-0 (paper)<br class="calibre2"/>
  ISBN-13: 978-0-226-52723-9 (e-book)</p>
<p class="para"><br class="calibre2"/></p>
<p class="para" id="para5">Library of Congress Cataloging-in-Publication Data</p>
<p class="para"><br class="calibre2"/></p>
<p class="para" id="para6">Miller, J. Hillis (Joseph Hillis), 1928–</p>
<p class="para-indent" id="para7">The conflagration of community : fiction before and after Auschwitz /</p>
<p class="para" id="para8">J. Hillis Miller.</p>
<p class="para-indent1">p. cm.</p>
<p class="para-indent">Includes index.</p>
<p class="para-indent" id="para9">ISBN-13: 978-0-226-52721-5 (cloth : alk. paper)</p>
<p class="para-indent" id="para10">ISBN-10: 0-226-52721-2 (cloth : alk. paper)</p>
<p class="para-indent" id="para11">ISBN-13: 978-0-226-52722-2 (pbk. : alk. paper)</p>
<p class="para-indent" id="para12">ISBN-10: 0-226-52722-0 (pbk. : alk. paper) 1. Holocaust, Jewish</p>
<p class="para" id="para13">(1939–1945), in literature. 2. Kafka, Franz, 1883–1924—Criticism and interpretation. I. Title.</p>
<p class="para-indent" id="para14">PN56.H55M55 2011</p>
<p class="para-indent" id="para15">809.3'9358405318—dc22</p>
<p class="para-right">2010052464</p>
<p class="para"><br class="calibre2"/></p>
<p class="para"><br class="calibre2"/></p>
<p class="para" id="para16"><img alt="" class="paper-permanence" src="OEBPS/Images/paper-permanence.jpg"/> This paper meets the requirements of ansi /niso z39.48-1992 (Permanence of Paper).</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyrightpage.vue?1393e48c